export default "__VITE_ASSET__BS9h7SoY__"